<template>
  <div></div>
</template>

<script>
/**
 * マップ上に拠点・基地局を表示するコンポーネント
 * @parent LiveMap
 * @props isReady: Boolean マップ情報が描画されているかのフラグ
 * @props mapEvent: String マップ上操作でのイベント名
 */
import { BaseStationMapLayer, MapSource } from "@/config/Map.js";
export default {
  name: "O.BaseStationLayer",
  props: {
    map: Object,
    isReady: { type: Boolean, default: false },
    mapEvent: String,
  },
  watch: {
    isReady() {
      if (this.isReady) {
        this.isMapReady();
      }
    },
  },
  methods: {
    /** レイヤーの描画処理 */
    isMapReady() {
      this.map.addLayer({
        id: BaseStationMapLayer.BaseStationLayer.id,
        type: "symbol",
        source: MapSource.BaseStationSource.id,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": "equipment-base-stations-maker",
          "icon-offset": [0, -15],
        },
      });
    },
  },
};
</script>

<style lang="scss"></style>
